export default __webpack_public_path__ + "static/media/ArrowRightIcon.06fa940b.svg";